import {
  applySnapshot,
  Instance,
  SnapshotIn,
  SnapshotOut,
  flow,
  types,
} from 'mobx-state-tree'

import {GiftModel} from './gift'
import createStore from "../../../lib/create-store";
import model from "../../messages/model";


const initState = {}

export const Model = types
  .model('BagModel', {
    list: types.array(GiftModel)
  })
  .actions((self) => {
    const update = (list) => {
      self.list = list
    }
    return {
      update
    }
  })


let {
  store,
  Provider,
  useStore
} = createStore(Model, initState);

export {
  store,
  Provider,
  useStore
}
